import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './styles.css';

// Root-level error boundary so render crashes show the actual error stack
// instead of a blank page. Includes a Reload button (full page refresh
// resets the bad state).
class RootErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null, info: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) { this.setState({ info }); console.error('[RootErrorBoundary]', err, info); }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: '2rem', maxWidth: 900, margin: '2rem auto', fontFamily: 'system-ui, sans-serif' }}>
          <h2 style={{ color: '#991b1b' }}>Something went wrong</h2>
          <p>The dashboard hit a render error. The details below help diagnose what crashed:</p>
          <pre style={{ background: '#fef2f2', color: '#991b1b', padding: '1rem', borderRadius: 4, overflow: 'auto', maxHeight: 300 }}>
            {String(this.state.err && this.state.err.stack || this.state.err)}
          </pre>
          {this.state.info && this.state.info.componentStack && (
            <pre style={{ background: '#f9fafb', color: '#374151', padding: '1rem', borderRadius: 4, overflow: 'auto', maxHeight: 300, fontSize: '0.85em' }}>
              {this.state.info.componentStack}
            </pre>
          )}
          <button onClick={() => window.location.reload()}
            style={{ background: '#0369a1', color: '#fff', border: 'none', padding: '0.5rem 1rem', borderRadius: 4, cursor: 'pointer', marginTop: '1rem' }}>
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RootErrorBoundary>
  </React.StrictMode>
);
